import React, { useState, Suspense, lazy } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Confirm } from "../components/Confirm";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useEffect, useMemo, useCallback } from "react";
import { getDeliveryTiers } from '../helper/Data';
import { UrlRepository } from "../helper/UrlRepository";

const SignupForm = lazy(() => import("../components/SignupForm"));

export function SignupPage() {
  const { formSubmitted, selectedVolumeTier } = useSelector((store) => store.signup);
  const [searchParams] = useSearchParams();

  const [deliveryTiers, setDeliveryTiers] = useState([]);

  const email = searchParams.get("email");
  const id = searchParams.get("id");
  const lang = searchParams.get('l');

  const getRedirectUrl = useCallback((lang) => {
    switch (lang) {
      case 'fr':
        return UrlRepository.SUCCESSFUL_SUBMISSION_TRIAL_FR;
      case 'es':
        return UrlRepository.SUCCESSFUL_SUBMISSION_TRIAL_ES;
      default:
        return UrlRepository.SUCCESSFUL_SUBMISSION_TRIAL_EN;
    }
  }, []);

  const getRedirectLowestTierUrl = useCallback((lang) => {
    switch (lang) {
      case 'fr':
        return UrlRepository.SUCCESSFUL_SUBMISSION_TRIAL_VOLUME_FR;
      case 'es':
        return UrlRepository.SUCCESSFUL_SUBMISSION_TRIAL_VOLUME_ES;
      default:
        return UrlRepository.SUCCESSFUL_SUBMISSION_TRIAL_VOLUME_EN;
    }
  }, []);

  const renderByFormStage = useMemo(() => {
    if (email && id) {
      return <Confirm />;
    } else {
      return (
        <Suspense>
          <SignupForm />
        </Suspense>
      );
    }
  }, [email, id]);

  const fetchDeliveryTiers = useCallback(async () => {
    if (deliveryTiers.length === 0) {
      const deliveryTiersData = await getDeliveryTiers();
      setDeliveryTiers(deliveryTiersData);
    }
  }, [deliveryTiers]);

  useEffect(() => {
    fetchDeliveryTiers();
  }, [fetchDeliveryTiers]);

  useEffect(() => {
    if (formSubmitted) {
      const lowestTier = deliveryTiers.length > 0 ? deliveryTiers[0].value : null;

      if (lowestTier && selectedVolumeTier.payload && selectedVolumeTier.payload === lowestTier) {
        window.location.href = getRedirectLowestTierUrl(lang);
      } else {
        window.location.href = getRedirectUrl(lang);
      }
    }
  }, [selectedVolumeTier, formSubmitted, deliveryTiers, getRedirectLowestTierUrl, lang, getRedirectUrl]);

  return (
    <Grid container spacing={0}>
      {renderByFormStage}
    </Grid>
  );
}